<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="addAcl" v-t="{ path: 'message.acl_dialog_title_add', args: { name: nodeInfo.name , userType: aclType[aclTypeIndex] } }">
                    </div>
                    <div v-else v-t="{ path: 'message.acl_dialog_title_edit', args: { name: nodeInfo.name , userType: aclType[aclTypeIndex] } }">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <UserSelection
                        :appData="appData"
                        :title="selectedTitle"
                        :selectedUsers="selectedUsers"
                        :forbidAllDelete="forbidAllDelete"
                        :selectionType="aclTypeIndex"
                        :showAdminUser="true"
                        @changeSelectedUser="handleChangeSelectedUser()"
                        ref="UserSelection">
                    </UserSelection>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button  class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import UserSelection from "./UserSelection.vue"
import charactercheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
        return {
            addAcl: false,
            forbidAllDelete: false,
            newAclTagList: {},
            selectedTitle: null,
            selectedUsers: null,
            selectionType: 0,
            aclType: [
                commonUtil.getMessageText(this.$i18n,"acl_dialog_item_read_user"),
                commonUtil.getMessageText(this.$i18n,"acl_dialog_item_write_user"),
                commonUtil.getMessageText(this.$i18n,"acl_dialog_item_link_user")
            ] ,
            disableSave: true
        };
    },
    methods: {
        handleChangeSelectedUser() {
            this.disableSave = false;
        },
        saveChange() {
            this.$emit('update', this.$refs.UserSelection.editTagList);
        },
    },
    created: function() {
        let aclUsers = [];
        switch(this.aclTypeIndex) {
            case 0:
                this.selectedUsers = this.aclRoUsers;
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"acl_dialog_item_read_user");
                break;
            case 1:
                this.selectedUsers = this.aclRwUsers;
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"acl_dialog_item_write_user");
                break;
            case 2:
                this.selectedUsers = this.aclLinkUsers;
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"acl_dialog_item_link_user");
                break;
        }
        if (this.selectedUsers.length == 0) {
            this.addAcl = true;
        }
        this.selectionType = this.aclTypeIndex;
        if ((this.nodeInfo.id == 1) || (this.nodeInfo.id == this.appData.tenantList[0].samlLayer)) {
            this.forbidAllDelete = true;
        }
        this.disableSave = true;
        return;
    },
    components: {
        UserSelection
    },
    props: ['appData','nodeInfo','aclRoUsers','aclRwUsers','aclLinkUsers','aclTypeIndex']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

